module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_puple.cdefca81.svg";